module.exports = __webpack_public_path__ + "static/tacoIcon-7547149462193521a0ab21658cce0121.png";